// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.unclaim-devices-page .pageHeading {
  margin: 30px 16.66%;
}
.unclaim-devices-page .btn-link {
  padding-top: 10px;
}
@media (max-width: 1024px) {
  .unclaim-devices-page .pageHeading {
    margin: 30px 2.66%;
    margin-top: 75px;
  }
  .unclaim-devices-page .btn-link {
    padding-top: 0;
  }
  .unclaim-devices-page .btn {
    padding: 0;
  }
  .unclaim-devices-page .buttons-section {
    padding: 30px 0;
  }
}

#point1 {
  margin: 0px 20px 0px 20px;
  display: list-item !important;
  list-style: disc;
}

#point2 {
  margin: 0px 20px 20px 20px;
  display: list-item !important;
  list-style: disc;
}

.explText {
  font-size: 16px;
}

.note {
  margin-bottom: 0px !important;
  font-size: 16px;
}

.select-wrapper {
  margin: 0 16.66%;
}
.select-wrapper .search-label {
  display: none !important;
}
.select-wrapper .buttons-section {
  border-top: 1px solid #d2d2d2;
  margin-top: 10px;
  padding: 30px 0 60px;
}
.select-wrapper .buttons-section .btnCancel {
  font: 1.8rem;
  font-family: "font-regular", "Omnes-ATT-W02", Arial;
}
.select-wrapper .buttons-section .btn-cancel {
  margin-right: 10px;
}
.select-wrapper tr th:first-child {
  width: 15%;
}
.select-wrapper tr th:last-child {
  width: 35%;
}
.select-wrapper .page-count p.col-md-4 {
  margin-bottom: 0;
  margin-top: -16px !important;
}
@media (max-width: 1024px) {
  .select-wrapper {
    margin: 0 15px;
  }
  .select-wrapper .page-count p.col-md-4 {
    margin-bottom: 0;
    margin-top: 30px !important;
  }
  .select-wrapper .btn-cancel {
    margin: 20px 0 0;
    text-align: center;
    width: 100%;
  }
  .select-wrapper .btn {
    text-align: center;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/cancel-participation/unclaim-devices/unclaim-devices.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA/IE;EACE,mBAAA;AAiJJ;AA7IE;EACE,iBAAA;AA+IJ;AFjII;EETA;IACE,kBAAA;IACA,gBAAA;EA6IJ;EA3IE;IACE,cAAA;EA6IJ;EA1IE;IAEE,UAAA;EA2IJ;EAxIE;IACE,eAAA;EA0IJ;AACF;;AAlIA;EACE,yBAAA;EACA,6BAAA;EACA,gBAAA;AAqIF;;AAlIA;EACE,0BAAA;EACA,6BAAA;EACA,gBAAA;AAqIF;;AAlIA;EACE,eAAA;AAqIF;;AAlIA;EACE,6BAAA;EACA,eAAA;AAqIF;;AAjIA;EACE,gBAAA;AAoIF;AAlIE;EACE,wBAAA;AAoIJ;AA3HE;EACE,6BAAA;EACA,gBAAA;EACA,oBAAA;AA6HJ;AA3HI;EACE,YAAA;EAEA,mDAAA;AA4HN;AA1HI;EACE,kBAAA;AA4HN;AAtHM;EACE,UAAA;AAwHR;AArHM;EACE,UAAA;AAuHR;AA5GI;EACE,gBAAA;EACA,4BAAA;AA8GN;AFlMI;EEoCJ;IAgEI,cAAA;EAkGF;EAvGI;IACE,gBAAA;IACA,2BAAA;EAyGN;EApGE;IACE,gBAAA;IACA,kBAAA;IACA,WAAA;EAsGJ;EAnGE;IACE,kBAAA;IACA,WAAA;EAqGJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.unclaim-devices-page {\n  //font-family: 'ATTAleckSans-Regular';\n  .pageHeading{\n    margin: 30px 16.66%;\n    //font-family: 'ATTAleckSans-Regular' !important;\n  }\n\n  .btn-link {\n    padding-top: 10px;\n  }\n\n  @include respond-to(small) {\n\n    .pageHeading{\n      margin: 30px 2.66%;\n      margin-top: 75px;\n    }\n    .btn-link {\n      padding-top: 0;\n    }\n\n    .btn {\n      //font-family: 'ATTAleckSans-Regular' !important;\n      padding: 0;\n    }\n\n    .buttons-section {\n      padding: 30px 0;\n    }\n  }\n}\n\nh2 {\n  //font-family: 'ATTAleckSans-Regular' !important;\n}\n\n#point1 {\n  margin: 0px 20px 0px 20px;\n  display: list-item !important;\n  list-style: disc;\n}\n\n#point2 {\n  margin: 0px 20px 20px 20px;\n  display: list-item !important;\n  list-style: disc;\n}\n\n.explText {\n  font-size: 16px;\n}\n\n.note {\n  margin-bottom: 0px !important;\n  font-size: 16px;\n  //font-family: 'ATTAleckSans-Regular' !important;\n}\n\n.select-wrapper {\n  margin: 0 16.66%;\n\n  .search-label {\n    display: none!important;\n  }\n\n  // .search {\n  //   .search-icon {\n  //     margin-top: -10px!important;\n  //   }\n  // }\n\n  .buttons-section {\n    border-top: 1px solid color(default, dark);\n    margin-top: 10px;\n    padding: 30px 0 60px;\n\n    .btnCancel {\n      font: 1.8rem;\n      //font-family: 'ATTAleckSans-Regular' !important;\n      font-family: 'font-regular', 'Omnes-ATT-W02', Arial;\n    }\n    .btn-cancel {\n      margin-right: 10px;\n    }\n  }\n\n  tr {\n    th {\n      &:first-child {\n        width: 15%;\n      }\n\n      &:last-child {\n        width: 35%;\n      }\n    }\n  }\n  .page-count{\n    \n    // .search-field{\n    //   width: 58.33%;\n    //   margin-left: 42%;\n    //   position: relative;\n    // }\n    p.col-md-4 {\n      margin-bottom: 0;\n      margin-top: -16px !important;\n    }\n}\n  @include respond-to(small) {\n    .page-count{\n      \n      // .search-field{\n      //   width: 100%;\n      //   margin-left: 0px !important;\n      //   position: relative;\n      // }\n      p.col-md-4 {\n        margin-bottom: 0;\n        margin-top: 30px !important;\n      }\n  }\n    margin: 0 15px;\n\n    .btn-cancel {\n      margin: 20px 0 0;\n      text-align: center;\n      width: 100%;\n    }\n\n    .btn {\n      text-align: center;\n      width: 100%;\n      //font-family: 'ATTAleckSans-Regular' !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
